import { ProviderMethods } from './AnalyticsProvider';
import { map } from 'lodash';

import logger from 'itrvl-logger';
const log = logger(__filename);

export default function NoOp() {
  const analytics = { name: 'NoOp' };

  // Build an event queue handler for each analytics method
  map(ProviderMethods, method => {
    log.trace('Adding:', method);
    analytics[method] = () => {
      const args = Array.prototype.slice.call(arguments);
      args.unshift(method);
      log.trace('TRACK:', method, args);
      return analytics;
    };
  });

  return analytics;
}
